export const UPDATE_FILE_UPLOAD_PROGRESS = 'UPDATE_FILE_UPLOAD_PROGRESS';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAILED = 'UPLOAD_FILE_FAILED';
export const RESET_FILE_UPLOAD_FAILED = 'RESET_FILE_UPLOAD_FAILED';
export const RESET_FILE_UPLOAD_PROGRESS = 'RESET_FILE_UPLOAD_PROGRESS';
export const UPDATE_FILE_INFORMATION_SUCCESS = 'UPDATE_FILE_INFORMATION_SUCCESS';
export const DOWNLOAD_FILE_FAILED = 'DOWNLOAD_FILE_FAILED';



// WEBPACK FOOTER //
// ./src/redux/files/FilesConstants.js